// @flow
import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { EventSelector } from 'modules/event/selector';
import { EventActions } from 'modules/event/actions';
import { Row, Col } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import { useViewport } from 'components/templates/viewportProvider';
import SortDropDown from 'components/atoms/sortDropdown';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { DateUtil } from 'utils/DateUtil';
import Event from 'assets/images/event.jpg';
import { HTMLView } from 'components/atoms/htmlView';
import sittingIcon from 'assets/images/diningIconWhite.png';
import stageIcon from 'assets/images/mic.png';
import standingIcon from 'assets/images/standing.png';
import RupeeIcon from 'assets/images/rupee-icon-pink.png';
import RightBlack from 'assets/images/rightb.png';
import { CURRENT_COUNTRY_CODE } from 'config/env';
import useEventUpdater from 'hooks/useEventUpdater';
import { isEmpty } from 'lodash';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: {
    venues: Array,
    event_title: string,
    description: string,
  },
};

const TicketTypeSelection = (props: Props) => {
  const {
    ticketSection: {
      venues,
      event_title,
      description,
      seating_ticket_price,
      standing_ticket_price,
      standing_capacity,
    },
    eventTableSeating,
    bookedStandingTickets,
    showTicketOverlay,
    setShowTicketOverlay,
  } = props.data;
  const {
    getBookedStandingTickets,
    getBookedTables,
    standingTickets = bookedStandingTickets,
    eventTableDetails = eventTableSeating,
    fnbPackages,
    getFnBPackages
  } = props;

  const { isMobile } = useViewport();
  const dates = venues && venues.eventDates;
  const countryCode = CURRENT_COUNTRY_CODE === '+1' ? 'USA' : 'INDIA';
  const validEventDates = useEventUpdater(dates, countryCode, true);
  let sortedDates = DateUtil.getSortedDates(validEventDates).reverse();
  //assigns the value of selected time object.
  const [selectedTime, setSelectedTime] = useState();
  const [dropdownValue, setDropdownValue] = useState();
  const [updateOverlay, setUpdateOverlay] = useState(0);
  const [overlayData, setOverlayData] = useState({});
  const height = standing_ticket_price > 0 ? '100vh' : '';
  const currentStandingTickets = overlayData?.availableStandingTickets;
  const currentAvailableTables = overlayData?.availableTables;
  // State to store previous values of standing tickets and available tables
  const [previousValues, setPreviousValues] = useState({
    availableStandingTickets: null,
    availableTables: null,
  });

  useEffect(()=> {
    if (!selectedTime || !extractDates?.some(date => date.id === selectedTime?.id)) {
      extractDates[0] && onSelect(extractDates[0]);
      setUpdateOverlay(prev => !prev);
    }
    if(selectedTime?.id){
      getBookedStandingTickets(selectedTime.id);
      getBookedTables(selectedTime.id);
    }
  },[sortedDates])

  useEffect(()=> {
    // Compare previous and current values of availableStandingTickets and availableTables
    if (
      previousValues.availableStandingTickets !== currentStandingTickets ||
      previousValues.availableTables !== currentAvailableTables
    ) {
      setUpdateOverlay((prev) => !prev);
    }
    setPreviousValues({
      availableStandingTickets: currentStandingTickets,
      availableTables: currentAvailableTables,
    });
  }, [sortedDates, currentStandingTickets, currentAvailableTables])

  useEffect(() => {
    const { href } = window.location;
    const hasId = href.split('#')[1];
    let timer;
    if (hasId) {
      timer = setTimeout(() => {
        const targetElement = document.getElementById('ticket-selection');
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
        onTicketTypeClick();
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, []);

  //calculates number of available tables which can be booked.
  let availableTables = 0;
  Object.values(eventTableDetails).map(row_data => {
    row_data.map(table => {
      if (!table.booked) {
        availableTables = availableTables + 1;
      }
    });
  });

  let availableStandingTickets =
    standing_capacity - standingTickets < 0
      ? 0
      : standing_capacity - standingTickets;

  // Use useEffect to update overlayData when ticket_details changes
  useEffect(() => {
    if(selectedTime?.id) {
      //details which needs to be send to the ticket-overlay.
        let ticket_details = {
          event_time: selectedTime,
          title: `${event_title} Tickets`,
          description: description,
          venue_name: venues.name,
          location: venues.location,
          seating_ticket_price,
          standing_ticket_price,
          availableStandingTickets,
          availableTables,
          table_seating: eventTableDetails,
          fnbPackages,
          outlet_id: venues.outlet_id
        };
      setOverlayData(ticket_details);
    }
  }, [availableTables, availableStandingTickets, updateOverlay, selectedTime, eventTableSeating, standing_capacity]);

  const extractDates = sortedDates.map(date => {
    let value = DateUtil.getEventDetailBannerDate(
      date.concert_date,
      date.start_time
    );
    return {
      value: date.id,
      label: value,
      id: date.id,
      concert_date: date.concert_date,
      end_time: date.end_time,
      music_event_venue_id: date.music_event_venue_id,
      start_time: date.start_time,
    };
  });

  const className =
    standing_capacity - bookedStandingTickets === 0
      ? 'ticket-col no-tickets'
      : 'ticket-col';

  const renderDates = () => {
    if (validEventDates.length === 1) {
      if (isMobile) {
        return (
          <h2 className={'event-date'}>
            {DateUtil.getEventDetailBannerDate(
              validEventDates && validEventDates[0].concert_date
            )}
          </h2>
        );
      } else {
        return (
          <h4 className={'event-date'}>
            {DateUtil.getEventDetailBannerDate(
              validEventDates && validEventDates[0].concert_date,
              validEventDates && validEventDates[0].start_time
            )}
          </h4>
        );
      }
    } else {
      return (
        <div className={'dates-dropdown'}>
          <SortDropDown
            options={extractDates}
            onSelect={option => onSelect(option)}
            value={dropdownValue}
            placeholder={extractDates[0]?.label}
            mode={'transparent'}
            className={'date-select-dropdown'}
          />
        </div>
      );
    }
  };

  // function called when a option is selected from the drop-down.
  const onSelect = option => {
    let selectedOption = extractDates.find(date => date.id === option.value);
    setSelectedTime(selectedOption);
    getBookedStandingTickets(selectedOption.id);
    getBookedTables(selectedOption.id);
    getFnBPackages();
    setDropdownValue(selectedOption.id);
  };

  const onTicketTypeClick = () => {
    setShowTicketOverlay(true);
  };

  const ticketOverlay = showTicketOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={overlayData}
        theme={'dark-theme'}
        type={'ticket-selection'}
        className={'ticketSelectionOverlay'}
        onClosePress={() => setShowTicketOverlay(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'Music & Events',
            breadcrumbLink: '#',
          },
          {
            breadcrumbName: `Book Your Tickets`,
            breadcrumbLink: '#',
          },
        ]}
        onSelect={onSelect}
        value={dropdownValue}
        placeholder={extractDates[0]?.label}
        extractDates={extractDates}
        updateOverlay = {updateOverlay}
      />
    </OverlayPortal>
  ) : null;

  const ticketTypeButtonMobile = (classname, type, price, showGst) => {
    const tickets_left =
      classname === 'standing'
        ? standing_capacity - bookedStandingTickets
        : true;
    if(price > 0) {    
      return (
        <div className={'ticket-type'} onClick={() => onTicketTypeClick()}>
          <div className={'type-name-container'}>
            <h1>{type}</h1>
            {tickets_left !== 0 && (
              <img className={'arrow-icon'} src={RightBlack} alt={'Rupees'} />
            )}
          </div>
          {price && tickets_left !== 0 ? (
            <div className={'pricing-container'}>
              <img className={'rupee-icon'} src={RupeeIcon} alt={'Rupees'} />
              <h4>{price} {type !== 'Standing Admission' ? ' (onwards)' : ''} {showGst ? '+ GST' : ''}</h4>
            </div>
          ) : (
            <span>Tickets not available.</span>
          )}
        </div>
      );
    }
    return null;  
  };

  const renderPriceContainer = (price_value, type, showGst) => {
    const tickets_left = standing_capacity - bookedStandingTickets;
    return (
      <div className={'lower-container'}>
        {type === 'standing' && tickets_left === 0 ? (
          <span className={'no-tickets'}>Tickets not available.</span>
        ) : (
          <>
            <div className={'pricing-container'}>
              <img src={RupeeIcon} alt={'Rupees'} className={'rupee-icon'} />
              <h3>{price_value}</h3>
              {type !== 'standing' ? (<h4> (onwards)</h4>) : ''}
            </div>
            {showGst && (
              <div className={'gst-container'}>
                <span>+ GST</span>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const renderColumns = (type, icon, price, priceFor, showGst) => {
    if(type === 'STAGE' || price > 0) {
      return (
        <Col
          className={priceFor === 'stage' ? 'ticket-col no-hover' : className}
          onClick={() => onTicketTypeClick()}
        >
          <div className={'inner-item'}>
            <img
              className={
                priceFor === 'stage' ? 'ticket-type-img small' : 'ticket-type-img'
              }
              src={icon}
              alt={'type'}
            />
            <span>{type}</span>
            {price && renderPriceContainer(price, priceFor, showGst)}
          </div>
        </Col>
      );
    }
    return null;
  };

  const getColumnName = (restaurantName) => {
    if((restaurantName === 'Terrace') || (restaurantName === 'Windmills BIAL') || (restaurantName === 'Oota,Whitefield')) {
      return 'ENTRY TICKET';
    }
    return 'STANDING TICKET';
  }

  const getColumnNameForMobile = (restaurantName) => {
    if((restaurantName === 'Terrace') || (restaurantName === 'Windmills BIAL') || (restaurantName === 'Oota,Whitefield')) {
      return 'Entry Ticket';
    }
    return 'Standing Admission';
  }

  const minSeatingPrice = (Array.isArray(seating_ticket_price) && !isEmpty(seating_ticket_price))
    ? seating_ticket_price.reduce((sum, curr) => Math.min(sum, curr.price), +Infinity) : 0;
  const maxSeatingPrice = (Array.isArray(seating_ticket_price) && !isEmpty(seating_ticket_price))
    ? seating_ticket_price.reduce((acc, curr) => Math.max(acc, curr.price), 0) : 0;
  const seatingHasGst = maxSeatingPrice > 499;
  const standingHasGst = standing_ticket_price > 499;

  return (
    <div id={'ticket-selection'}>
      <MediaQuery minDeviceWidth={575.6}>
        <div className={'ticket-selection'}>
          <div className={'inner-content'}>
            <Row className={'intro-row'}>
              <Col md={6}>
                <h1>{event_title}</h1>
                {/* <p>{description}</p> */}
                <HTMLView
                  html={description}
                  tagName={'p'}
                  className={'description'}
                />
              </Col>
              <Col md={6}>
                <h3 className={'outlet-name'}>{venues.name}</h3>
                <h3 className={'outlet-location'}>{venues.location}</h3>
                {renderDates()}
              </Col>
            </Row>
            {(standing_ticket_price > 0 || minSeatingPrice > 0) && (
              <Row className={'selection-row'}>
                {renderColumns(
                  getColumnName(venues.name),
                  standingIcon,
                  standing_ticket_price,
                  'standing',
                  standingHasGst
                )}
                {renderColumns(
                  'SEATING TICKET',
                  sittingIcon,
                  minSeatingPrice,
                  'sitting',
                  seatingHasGst
                )}
                {renderColumns('STAGE', stageIcon, null, 'stage', false)}
              </Row>
            )}
          </div>
          {ticketOverlay}
        </div>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={575}>
        <div className={'ticket-selection-mobile'} style={{ height }}>
          <div className={'inner-section'}>
            <div className={'upper-section'}>
               <h2>Available seating options</h2>
                <div className='dates-container'>
                  <h2>for</h2>
                  {renderDates()}
                </div>
              <HTMLView
                tagName={'p'}
                className={'description'}
                html={description}
              />
            </div>
            {(standing_ticket_price > 0 || minSeatingPrice > 0) && (
              <div className={'type-buttons'}>
                {ticketTypeButtonMobile(
                  'sitting',
                  'Seated Admission',
                  minSeatingPrice,
                  seatingHasGst
                )}
                {ticketTypeButtonMobile(
                  'standing',
                  getColumnNameForMobile(venues.name),
                  standing_ticket_price,
                  standingHasGst
                )}
              </div>
            )}
          </div>
        </div>
        {ticketOverlay}
      </MediaQuery>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    standingTickets: EventSelector.getEventStandingTickets(state),
    eventTableDetails: EventSelector.getEventBookedTables(state),
    fnbPackages: EventSelector.getEventFnBPackages(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { getBookedStandingTickets, getBookedTables, getFnBPackages } = EventActions;
  return bindActionCreators(
    {
      getBookedStandingTickets,
      getBookedTables,
      getFnBPackages,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketTypeSelection);
